var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallmessageicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2224 15.5552H9.7776C8.24529 15.5552 6.77573 14.9465 5.69222 13.863C4.60871 12.7795 4 11.3099 4 9.7776C4 8.24529 4.60871 6.77573 5.69222 5.69222C6.77573 4.60871 8.24529 4 9.7776 4H13.6C15.2974 4 16.9252 4.67428 18.1255 5.87452C19.3257 7.07475 20 8.70261 20 10.4C20.0013 11.4931 19.7225 12.5683 19.1904 13.5231C18.6582 14.4779 17.8903 15.2805 16.96 15.8544L10.2224 20V15.5552Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallmessageicon);
export default __webpack_public_path__ + "static/media/smallmessageicon.b9f11a0ad71342fd8168b44722542a5a.svg";
export { ForwardRef as ReactComponent };